const { useEffect, useRef } = require("react");

function useDidValueChange(value, label = "Value") {
  const prevRef = useRef();

  useEffect(() => {
    if (prevRef.current && prevRef.current !== value) {
      console.warn(`[useDidValueChange] ${label} changed:`, {
        prev: prevRef.current,
        next: value,
      });
    }
    prevRef.current = value;
  }, [value, label]);
}

export default useDidValueChange;
